<template>
  <div>
    <div class="container mx-auto flex flex-col laptop:mt-150px pt-10 md:pt-16 mb-12 md:mb-24">
      <div class="laptop:w-5/12 p-5 md:p-0 laptop:pl-0 laptop:mx-24 md:mx-8 md:w-1/2">
        <MARSTitle h1 marginBottom="mb-4 laptop:mb-12"><div v-html="$t('dovesono.title').toString()" /></MARSTitle>
      </div>
      <div class="p-5 md:p-0 laptop:pl-0 laptop:mx-24 md:mx-8 md:w-2/3 lg:w-1/2">
        <p class="text-standard italic m-4 mx-auto laptop:text-slg md:text-base md:w-full" v-html="$t('dovesono.subTitle').toString()" />
      </div>
    </div>

    <div class="container columns mx-auto mb-16 md:mb-32 px-5 md:px-0 md:w-2/3">
      <p v-for="(text, index) of $tm('dovesono.textTop')" :key="index" class="text-standard mb-4 mx-auto laptop:text-slg md:text-base md:w-full" v-html="$rt(text)" />
    </div>

    <DoveSonoBlock
      v-for="(step, stepIndex) of steps" :key="`step${stepIndex}`"
      :imageUrl="images[stepIndex]"
      :step="step"
      :stepIndex="stepIndex"
    />

    <div class="mb-20">
      <!-- spacer -->
    </div>
  </div>
</template>

<script lang="ts">
import MARSTitle from '@/components/MARSTitle.vue'
import DoveSonoBlock from '@/components/DoveSonoBlock.vue'

import img1 from '~/assets/img/dovesono/dovesono1.webp'
import img2 from '~/assets/img/dovesono/dovesono2.webp'
import img3 from '~/assets/img/dovesono/dovesono3.webp'
import img4 from '~/assets/img/dovesono/dovesono4.webp'

interface Step {
  title: string
  subTitle: string
  descriptionTop: string[]
  descriptionOptionsList: string[]
  descriptionOptionsDetails: string[]
  operationsWhat: string
  operationsHow: {
    title: string
    link: string
  }[]
  toolsWhat: string
  toolsHow: {
    title: string
    link: string
  }[]
}

export default defineNuxtComponent({
  components: { MARSTitle, DoveSonoBlock },
  data() {
    return {
      images: [
        img1,
        img2,
        img3,
        img4,
      ]
    }
  },
  computed: {
    steps(): Step[] {
      // TODO: can we do this?
      const r = this.$tm('dovesono.steps') as unknown as Step[]
      return r
    }
  }
})
</script>

<style scoped></style>
